import React from 'react'
import PropTypes from 'prop-types'
import { useEffect } from 'sb-hooks'
import Media from 'sb-media'
import sentry from 'common/helpers/analytics/sentry'


const SrcSize = (props) => {
  const { src, w, h, mW, mH, children } = props

  useEffect(() => {
    if (!src) {
      sentry.captureException('Missed "src" value', {
        extra: {
          props,
          placement: 'SrcSize component',
        },
      })
    }
  }, [ src ])

  return (
    <Media retina>
      {
        (isRetina) => (
          <Media mobile>
            {
              (isMobile) => {
                const prop = Boolean(w) ? 'w' : 'h'
                const desktopValue = w || h
                const value = isMobile ? mW || mH || desktopValue : desktopValue
                const size = value * (isRetina ? 2 : 1)
                const result = src ? `${src}?${prop}=${size}` : null

                return children(result)
              }
            }
          </Media>
        )
      }
    </Media>
  )
}

SrcSize.propTypes = {
  src: PropTypes.string.isRequired,
  w: PropTypes.number,
  h: PropTypes.number,
  mW: PropTypes.number,
  mH: PropTypes.number,
}

export default SrcSize
